export const GET_CONFIGURAZIONE_DATA_AND_LOADING =
  "GET_CONFIGURAZIONE_DATA_AND_LOADING";
export const GET_CONFIGURAZIONE_DETAILS_DATA_AND_LOADING =
  "GET_CONFIGURAZIONE_DETAILS_DATA_AND_LOADING";
export const GET_CONFIGURAZIONE_FILTER_DATA_AND_LOADING =
  "GET_CONFIGURAZIONE_FILTER_DATA_AND_LOADING";
export const UPDATE_CONFIGURAZIONE_LOADING = "UPDATE_CONFIGURAZIONE_LOADING";
export const GET_UPDATE_FORM_DATA = "GET_UPDATE_FORM_DATA";
export const GET_PRINCIPALE_TREE_OBJECT = "GET_PRINCIPALE_TREE_OBJECT";
export const GET_SECONDARIO_TREE_OBJECT = "GET_SECONDARIO_TREE_OBJECT";
export const DUPLICATE_CONFIGURAZIONE = "DUPLICATE_CONFIGURAZIONE";
export const GET_CONFIGURAZIONE_REFRESH_LOADING =
    "GET_CONFIGURAZIONE_REFRESH_LOADING";
export const UPDATE_LAST_UPDATED_VALUE = "UPDATE_LAST_UPDATED_VALUE"